import CommonLanguageSwitch from './LanguageSwitch';

export default CommonLanguageSwitch;
